export const PERMITS = {
  get 匿名权限() { return -2 },
  get 公共权限() { return -1 },
  get 系统配置() { return 0 },
  get 角色管理() { return 1 },
  get 用户管理() { return 2 },
  get 公告管理() { return 3 },
  get 单位管理() { return 4 },
  get 水源管理() { return 5 },
  get 出勤管理() { return 6 },
  get APP权限() { return 7 },
  get APP管理员() { return 8 },
}

export const UNIT_TYPES = {
  get 消防单位() { return 1 },
  get 政府乡镇专职队() { return 2 },
  get 企业专职队() { return 3 },
  get 微站() { return 4 },
  get 一警六员() { return 5 },
}

export const ATTACH_TYPES = {
  get APP消息() { return 1 },
  get 重要公告() { return 2 },
}


// WEBPACK FOOTER //
// ./src/cfg.js